import { produce } from 'immer'
import { type InfiniteData } from 'react-query'

import { type PollAnswer } from 'components-ref/molecules'
import { type Story } from 'types/api/story'
import { type IInfinitePage } from 'types/interfaces/ITypes'
import { integrateStoryAnswer } from 'utils/stories'

export const updatePollStory = (
  story: Story,
  storyId: string,
  params: PollAnswer
): Story => {
  if (String(story.id) !== storyId || !story.poll) {
    return story
  }

  return integrateStoryAnswer({
    story,
    answer:
      params.answer != null
        ? String(params.answer)
        : null,
    answerId: params.answerId
  })
}

export const updatePollStories = (
  stories: Story[],
  storyId: string,
  params: PollAnswer
): Story[] => {
  if (!stories.some(story => String(story.id) === storyId)) {
    return stories
  }

  return stories.map(story =>
    updatePollStory(story, storyId, params)
  )
}

export const updateHomeFeedStoryPoll = (
  data: InfiniteData<IInfinitePage>,
  storyId: string,
  params: PollAnswer
): InfiniteData<IInfinitePage> => {
  return produce(data, draft => {
    for (const page of draft.pages) {
      for (const post of page.page.data.data) {
        if (!post.stories?.length) continue

        const story = post.stories.find(
          item => String(item.id) === storyId
        )

        if (!story?.poll) continue

        Object.assign(
          story,
          updatePollStory(story, storyId, params)
        )
      }
    }
  })
}